import Footer from '@/components/layout/Footer'
import Hero from '@/components/sections/Hero'
import Features from '@/components/sections/Features'
import FacilitySelect from '@/components/sections/FacilitySelect'
import Sustainability from '@/components/sections/Sustainability'
import RareEarthElements from '@/components/sections/RareEarthElements'
import CTA from '@/components/sections/CTA'

export default function Home() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <main>
        <Hero />
        <Features />
        <RareEarthElements />
        <FacilitySelect />
        <Sustainability />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}
